import { FC, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from 'atoms/layout/flex';

const Root = styled.article`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: inherit;
  border: 1px solid var(--c-neutral-150);
`;
const Header = styled(SBHorizontal)`
  min-height: calc(5 * var(--unit));
  align-items: start;
`;
const Content = styled(Vertical).attrs({ gap: 2 })`
  flex: 1;
  padding: var(--double-unit);
`;
const Field = styled.div`
  flex: 1;
  width: 100%;
`;
const FooterWrapper = styled.div`
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  overflow: hidden;
`;

export type Props = {
  children: ReactNode;
  header?: ReactNode;
  subHeader?: ReactNode;
  subFooter?: ReactNode;
  footer?: ReactNode;
};

export const LineupLayout: FC<PropsWithChildren<Props>> = ({
  children,
  header,
  subHeader,
  subFooter,
  footer,
}: Props) => {
  return (
    <Root>
      <Content>
        {(header || subHeader) && (
          <Vertical>
            {header && <Header>{header}</Header>}
            {subHeader}
          </Vertical>
        )}
        <Field>{children}</Field>
      </Content>
      {(subFooter || footer) && (
        <FooterWrapper>
          {subFooter && <aside>{subFooter}</aside>}
          {footer && <footer>{footer}</footer>}
        </FooterWrapper>
      )}
    </Root>
  );
};
